import { GstBacklog, GstZohoRegistration } from "../entities/CompanySettings";
import { SettingsRepository } from "../repositories/SettingsRepository";

/**
 * ZOUR-19 — re-reads the GST panel's read-only blocks.
 *
 * Backs the Refresh button beside "In Zoho Books". Deliberately separate from
 * GetGstSettingsUseCase: refreshing what Zoho says must not replace the form's
 * values and discard edits the user has not saved yet.
 */
export class GetGstZohoStatusUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(signal?: AbortSignal): Promise<{ zoho: GstZohoRegistration; backlog: GstBacklog }> {
    return this.repository.getGstZohoStatus(signal);
  }
}
